<script>
  // Перенос Cell из pass.tsx — ячейка дорожки наград. Состояния читаются без
  // наведения: заперта (тускло), доступна (рамка+кнопка), получена (галочка),
  // премиум без подписки (замок поверх).
  import { t } from '../../i18n.js';
  import { itemPhoto, vipPhoto, clothesPhoto, parseClothesData } from '../photofn.js';
  import { tierArt } from '../passart.js';
  import Ico from '../ico.svelte';
  import Photo from '../photo.svelte';
  import Chip from '../ui/chip.svelte';
  import GoldBtn from '../ui/goldbtn.svelte';

  export let tier;
  export let track = 'free';
  export let reached = false;
  export let claimed = false;
  export let premium = false;
  export let reward = undefined;
  export let onClaim = () => {};

  /**
   * Настоящие фото награды — та же логика, что у старого пропуска (getPng.js):
   * предмет — фото с зеркала (одежда — по drawable из Data), VIP — карточка
   * привилегии. Пустой список — падаем на нарисованный арт.
   */
  const rewardSrcs = (r) => {
    if (!r) return [];
    const out = [];
    if (r.image) out.push(r.image.startsWith('http') ? r.image : itemPhoto(r.image.replace(/\.png$/i, '')));
    if (r.rtype === 0 && r.itemId != null) {
      if (r.itemId < 0) {
        const c = parseClothesData(r.data);
        const u = clothesPhoto(r.itemId, c.drawable, c.texture, c.male);
        if (u) out.push(u);
      } else out.push(itemPhoto(r.itemId));
    } else if (r.rtype === 1) {
      out.push(vipPhoto(Math.max(0, Math.min(4, r.itemId ?? 0))));
    }
    return out;
  };

  $: art = tierArt(tier, track);
  $: blocked = track === 'premium' && !premium;
  $: can = reached && !claimed && !blocked;
</script>

{#if !art}
  <!-- На бесплатной линии награда есть не на каждом уровне — «пусто», а не прочерк. -->
  <div class="mn-cell void locked">
    <div class="mn-shot"><Ico n="minus" s={22} class="ph" /></div>
    <div class="lb" style="color:var(--ink-mute)">{t('m.bp.noReward')}</div>
    <div class="act"></div>
  </div>
{:else}
  <div class={'mn-cell' + (track === 'premium' ? ' prem' : '') + (can ? ' can' : '') + (!reached ? ' locked' : '') + (claimed ? ' got' : '')}>
    <div class={'rar mn-r' + art.rarity}></div>
    <!-- сначала настоящие фото награды с сервера, нарисованный арт — запасной -->
    <Photo src={[...rewardSrcs(reward), art.img]} alt={reward?.title || art.label} icon="battlepass" />
    <div class="lb">{reward?.title || art.label}{(reward?.count ?? 0) > 1 ? ` ×${reward.count}` : ''}</div>
    <div class="act">
      {#if claimed}<Chip tone="pos"><Ico n="check" s={13} />{t('m.taken')}</Chip>
      {:else if can}<GoldBtn size="sm" on:click={onClaim}>{t('m.take')}</GoldBtn>{/if}
    </div>
    {#if blocked}<div class="veil"><Ico n="lock" s={20} /></div>{/if}
  </div>
{/if}
